import React from 'react'
import moment from 'moment'
import Card from '@mui/material/Card'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

export const StatTile = ({ label, value, caption, color, loading, onClick }) => (
  <Card
    variant="outlined"
    onClick={onClick}
    sx={{
      p: 1.5,
      flex: 1,
      minWidth: 140,
      cursor: onClick ? 'pointer' : 'default',
      transition: 'border-color 120ms ease, background-color 120ms ease',
      '&:hover': onClick && { borderColor: `${color}.main` },
    }}
  >
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography
      sx={{ fontSize: '1.6rem', fontWeight: 800, lineHeight: 1.2 }}
      color={`${color}.main`}
    >
      {loading ? <Skeleton width={40} /> : (value ?? 0)}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {caption}
    </Typography>
  </Card>
)

const DashboardCards = ({
  loading,
  data,
  setSearchParams,
  performSearch,
  onOpenAccessLogs,
}) => {
  const applySearch = (params) => {
    performSearch(params)
    setSearchParams((prev) => ({ ...prev, ...params }))
  }

  return (
    <Stack direction="row" gap={1.5} flexWrap="wrap">
      <StatTile
        label="In Progress"
        value={data?.drafts}
        caption="Draft forms currently being edited"
        color="warning"
        loading={loading}
        onClick={() =>
          applySearch({
            status: ['Draft'],
            types: ['ePCR', 'Fast Track', 'Critical Care'],
            startDate: null,
            endDate: null,
          })
        }
      />
      <StatTile
        label="Recently Created"
        value={data?.recentlyCreated}
        caption="Created in the last 48 hours"
        color="anMainBlue"
        loading={loading}
        onClick={() =>
          applySearch({
            startDate: moment().subtract(48, 'hours'),
            endDate: moment(),
            status: ['Draft', 'Submitted'],
            types: ['ePCR', 'Fast Track', 'Critical Care'],
          })
        }
      />
      <StatTile
        label="Being Shared"
        value={data?.activeShareCodes}
        caption="Share codes that can be used right now"
        color="success"
        loading={loading}
        onClick={
          onOpenAccessLogs
            ? () =>
                onOpenAccessLogs({
                  kinds: ['shareCreated', 'shareRevoked', 'external'],
                  startDate: moment().subtract(7, 'days').startOf('day'),
                  endDate: moment().endOf('day'),
                })
            : undefined
        }
      />
    </Stack>
  )
}

export default DashboardCards
